export { default as PersonalTab } from './PersonalTab';
export { default as RankTab } from './RankTab';
export { default as SettingsTab } from './SettingsTab';
export * from './RegistrationTab';
export * from './MedalsTab';
export * from './TransactionsTab';



// WEBPACK FOOTER //
// ./src/pages/base-managment/soldiers/SoldierPage/tabs/index.js